import { transformSubmissionData, transformSubmission } from '../utils/transformSubmissionData';
import { checkTokenExpiration } from '../utils/checkTokenExpiration';
import { getCurrentSession } from '../../lib/authentication';
import { isDefined } from '../utils/utilities';
import trim from 'lodash/trim';
import { get } from 'lodash';

export const getSubmissionsPost = body => {
    return getCurrentSession()
    .then(result => {
        const { accessToken } = result;
    return apigClient
        .apiGetSubmissionsPost({}, body, {
            headers: {
                Authorization: accessToken
            }
        })
        .then(resp2 => {
            if (resp2.status === 200) {
                if (resp2.data.submission) {
                    try {
                        return transformSubmissionData(resp2.data.submission);
                    } catch (err) {
                        throw new Error('Error transforming submission data', err);
                    }
                } else {
                    throw new Error('Error retrieving submission data');
                }
            } else {
                console.error('Error While Accessing Submissions DB.');
            }
        })
        .catch(error => {
            // if there is a problem accessing the api with authorization errors
            if (error.status === 0 || error.status === 403) {
                return error.status;
            }
        });
    });
};
export const submissionsPost = submission => {
    return getCurrentSession()
    .then(result => {
        const { accessToken } = result;
        return apigClient.submissionsPost({ }, submission,
            {
                headers: {
                    Authorization: accessToken
                }
            }).then(resp => {
                return resp.data;
            })
        })
        .catch(error => {
            console.error(error);
            if (error.status === 0 || error.status === 403) {
                return Promise.resolve({ status: 'authError' });
            }
            return Promise.reject({
                _error: error.message
            });
        });
};

const submissionIdGet = (params, jwtToken) => {
    return apigClient
        .apiGetSubmissionIdGet(
            params,
            {},
            {
                headers: {
                    Authorization: jwtToken
                }
            }
        )
        .catch(error => {
            return Promise.reject(error);
        });
};

const submissionRevisionsIdGet = (params, jwtToken) => {
    return apigClient
        .apiGetSubmissionRevisionsIdGet(
            params,
            {},
            {
                headers: {
                    Authorization: jwtToken
                }
            }
        )
        .catch(error => {
            return Promise.reject(error);
        });
};

export function getSubmission(user, params) {
    return Promise.all([checkTokenExpiration(user), getCurrentSession()]).then(results => {
        const [expirationToken, currentSession] = results;
        const { accessToken } = currentSession;
        return submissionIdGet(params, accessToken);
    });
}


export function getSubmissionRevisions(user, params, flag = true) {
    return Promise.all([checkTokenExpiration(user), getCurrentSession(flag)]).then(results => {
        const [expirationToken, currentSession] = results;
        const { accessToken } = currentSession;
        return submissionRevisionsIdGet(params, accessToken);
    });
}

export function setClearance(id, status) {
  return getCurrentSession()
    .then(({ accessToken }) => {
      return apigClient.apiSetClearanceIdPost(
        { id: id },
        [{ fieldName: 'clearanceStatus', fieldValue: status }],
        {
          headers: {
            Authorization: accessToken,
          },
        },
      ) }
    )
    .then((response) => Promise.resolve(response))
}

export function getClearanceInfo(id) {
    return getCurrentSession()
    .then(result => {
        const { accessToken } = result;
        return apigClient.apiGetClearanceInfoIdGet({ id: id }, {}, {
            headers: {
                Authorization: accessToken
            }
        }).then(resp => {
            if (resp.data !== null && isDefined(resp.data.sgsResult)) {
                return Promise.resolve(resp.data.sgsResult);
            } else return Promise.resolve(null);
        });
    })
}
export function saveSubmission(submission, user, person) {
    if (person.id && person.brokerId) {
        submission.userId = person.id;
        submission.brokerId = person.brokerId;
    }

    if ((submission.brokerId == null || submission.brokerId === '')) {
        return Promise.reject('brokerId not defined')
    }
    return checkTokenExpiration(user).then(() => {
        return submissionsPost(submission);
    });
}
export function getClearance(params, user) {
    const apiparams = {
        'insured-name': trim(params.name),
        'insured-street-address': trim(params.addresses[1].primaryInsuredAddress.replace('#', '')),
        'insured-city': trim(params.addresses[1].primaryInsuredCity),
        'insured-state': trim(params.addresses[1].primaryInsuredState),
        'insured-zip': trim(params.addresses[1].primaryInsuredZipcode),
        'project-street-address': trim(params.addresses[0].projectAddress.replace('#', '')),
        'project-city': trim(params.addresses[0].projectCity),
        'project-state': trim(params.addresses[0].projectState),
        'project-zip': trim(params.addresses[0].projectZipcode),
        'user-id': user.id,
        'brokerage-id': user.brokerId,
        product: params.type.toUpperCase(),
        'ref-id': ''
    };

    return checkTokenExpiration(user).then(() => {
        return apigClient.clearanceGet(apiparams, {}, {});
    });
}

export function updateEdgeNumber(submissionId, edgeNumber, user) {
    return checkTokenExpiration(user).then(() => {
        return apigClient.edgeNumberPost({}, { submissionId, edgeNumber }, {});
    });
}

export function submissionsPut(id, submission) {
    return getCurrentSession()
    .then(result => {
        const { accessToken } = result;

        return apigClient.submissionsPut({ id }, submission,
            {
                headers: {
                    Authorization: accessToken
                }
            });
        })
}

export function submissionsUnbindPut(id, submission) {
    return getCurrentSession()
    .then(result => {
        const { accessToken } = result;
        return apigClient.submissionsUnbindPut({ id }, submission,
            {
                headers: {
                    Authorization: accessToken
                }
            });
        })
}

export const downloadQuoteSubmission = (user, submissionID, flag) => {
    return Promise.all([checkTokenExpiration(user), getCurrentSession(flag)]).then(results => {
        const [expirationToken, currentSession] = results;
        const { accessToken } = currentSession;
        return apigClient.submissionsIdQuoteGet(
            { id: submissionID },
            {},
            {
                headers: {
                    Authorization: accessToken
                }
            }
        )
            .catch(error => {
                console.log('error on fetching submissionQuote');
                return Promise.reject(error);
            });
    });
};

export const downloadQuoteSpecimenSubmission = (user, submissionID, flag = true, isDeductibleSpecimen = false, isExcessSpecimen = false, revisionNumber) => {
    return Promise.all([checkTokenExpiration(user), getCurrentSession(flag)]).then(results => {
        const [expirationToken, currentSession] = results;
        const { accessToken } = currentSession;
        return apigClient.submissionsIdQuoteSpecimenGet(
            { id: submissionID, isDeductibleSpecimen, isExcessSpecimen, revisionNumber },
            {},
            {
                headers: {
                    Authorization: accessToken
                }
            }
        )
            .catch(error => {
                console.log('error on fetching submissionQuote', error);
                return Promise.reject(error);
            });
    });
};

export const downloadQuoteRevisionSubmission = (user, submissionID, revisionNumber, filterByCoverage = null, flag) => {
    let params = {
        id: submissionID,
        revisionNumber,
    }
    if (filterByCoverage !== null) {
        params =  {
            ...params,
            filterByCoverage
        }
    }
    return Promise.all([checkTokenExpiration(user), getCurrentSession(flag)]).then(results => {
        const [expirationToken, currentSession] = results;
        const { accessToken } = currentSession;
        return apigClient.submissionsIdRevisionQuoteGet(
            params,
            {},
            {
                headers: {
                    Authorization: accessToken
                }
            }
        )
            .catch(error => {
                console.log('error on fetching submissionQuote');
                return Promise.reject(error);
            });
    });
};

export const loadArgopi = submission => {
    return getCurrentSession()
    .then(result => {
        const { accessToken } = result;
        return apigClient.loadArgopi({ }, submission,
            {
                headers: {
                    Authorization: accessToken
                }
            }).then(resp => {
                return resp.data;
            })
        })
        .catch(error => {
            console.error(error);
            if (error.status === 0 || error.status === 403) {
                return Promise.resolve({ status: 'authError' });
            }
            return Promise.reject({
                _error: error.message
            });
        });
};
